var map = {
	"./locale-de.json": [
		1539,
		539
	],
	"./locale-en.json": [
		7601
	],
	"./locale-en_GB.json": [
		3938,
		938
	],
	"./locale-es.json": [
		8476,
		476
	],
	"./locale-fr.json": [
		3893,
		893
	],
	"./locale-it.json": [
		9083,
		83
	],
	"./locale-ja.json": [
		6767,
		498
	],
	"./locale-ko.json": [
		440,
		440
	],
	"./locale-nl.json": [
		8742,
		742
	],
	"./locale-pt.json": [
		4991,
		991
	],
	"./locale-ru.json": [
		5927,
		927
	],
	"./locale-zh_CN.json": [
		8255,
		255
	],
	"./locale-zh_TW.json": [
		6429,
		429
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7919;
module.exports = webpackAsyncContext;